import React, { /*useContext,*/ useEffect, useRef, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
//import { authContext } from '../../context/AuthContext';
import SimpleTable from '../helper/SimpleTable';
import Loading from '../helper/Loading';
import axios from 'axios';
import moment from 'moment';
import UserInfoDisplay from '../helper/UserInfoDisplay';
import { withTranslation } from 'react-i18next';


const ViewSubModule = props => {
    const history = useHistory()
    //const userMain = useContext(authContext)
 //   const roles = userMain.roles
    const params = useParams()

    const mounted = useRef(true)

    const {t} = props

    const tableCells = [
        { id: 'STARTDATE', label: t('SubModule.Started'), centered: false },
        { id: 'ENDDATE', label: t('SubModule.Finished'), centered: false },
        { id: 'humanTime', label: t('SubModule.TotalTime'), centered: false },
        { id: 'SYSTEMINFO', label: t('SubModule.SystemInfo'), centered: false },
        { id: 'statusView', label: t('SubModule.Status'), centered: false },
    ];

    const state = history.location.state
    const [data, setData] = useState(null) // the session history for the table
    const [userData, setUserData] = useState({ DOB: null, email: null, first_name: null, last_name: null, username: null }) // user account info from the get request, could have used authContext, but admin and employer will not be able to use it, so I just made dashboard also use the same get request

    // looks for the admin role
   // const enableActions = roles.isUserAdmin === 1 ? true : false

    // if from admin, use the state username, otherwise use authcontect username
    //const username = (props.from==="admin" && state) ? state.username : user.username
    const username = state.username

    console.log("username: " + username);
   // const token = userMain.accessToken

    useEffect(() => {
        async function getData() {

            const res = await axios.all([
                axios.get('/api/courseProgress/all', {
                    params: {
                        username: username,
                        COURSEID: params.id,
                        trainingId: state.trainingId
                    }

                }),
                axios.get('/api/user/info/' + username)
            ])
            const moduleData = res[0].data.course.map(e => {

                // fomatting the time with this causes issues if the millisecond time is larger than a day (wraps back around to the next day, max of 23:59:59)
                e.humanTime = e.TOTALTIMEINMILLISECOND ? moment.utc(e.TOTALTIMEINMILLISECOND).format('HH:mm:ss') : null
                if (e.STARTDATE !== null && e.STARTDATE !== undefined) 
                    e.STARTDATE = moment(e.STARTDATE).format('YYYY-MM-DD hh:mm:ss A')
                if (e.ENDDATE !== null && e.ENDDATE !== undefined) 
                    e.ENDDATE = moment(e.ENDDATE).format('YYYY-MM-DD hh:mm:ss A')
                e.statusView =  e.STATUS ? t('lmsStatus.Status', { context: e.STATUS }) : null;

                return e
            })

            if (mounted.current) {
                setData(moduleData)
                setUserData(res[1].data.user)

            }
        }

        getData()

        return () => mounted.current = false
    }, [params.id, username, state.trainingId])


    // STAKEHOLDERS want deletetion to be removed, comment this out after development done
    // const onDelete = async (id) => {
    //     const res = await axios.delete('/api/courseProgress/' + id, {
    //         headers: {
    //             'Authorization': token
    //         }
    //     })
    //     console.log(res)
    //     if (res.status === 200) {
    //         const newData = data.filter(e => e.id !== id)
    //         setData(newData)
    //     }
    // }

    //const actionButtons = [
    //     { icon: "delete", action: onDelete, delete: true }
    // ];

    return (
        <>
            <PageHeader title={state ? t('SubModule.CourseProgress') + "'" + state.label + "'" : t('SubModule.Course') } cancel={history.goBack} />
            {data === null ? <Loading /> :
                data.length === 0 ? <h1> {t('SubModule.NoDataCourseID')}{params.id}</h1> :
                    <>
                        <UserInfoDisplay userData={userData} />
                        <br />
                        <p>{t('SubModule.NumberOfSessions')} {data.length}</p>
                        <p>{t('SubModule.CompletetionStatus')} {state ? state.STATUS : ""}</p>
                        <SimpleTable
                            data={data}
                            cellKey={"id"}
                            tableCells={tableCells}
                           // actionButtons={actionButtons}
                            //actions={enableActions} // buttons enabled if the admin role is found in user account data
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(ViewSubModule);